import api from './api';

// Tipos para las respuestas de la API
interface ListarProveedoresResponse {
  success: boolean;
  data: Proveedor[];
  pagination?: {
    total: number;
    page: number;
    limit: number;
    totalPages: number;
  };
  total?: number; // Mantener compatibilidad hacia atrás
}

interface Proveedor {
  id: number;
  nombre: string;
  rut: string;
  email: string;
  telefono?: string;
  categoria: string;
  direccion?: string;
  activo: boolean;
  created_at: string;
  updated_at: string;
}

interface CreateProveedorRequest {
  nombre: string;
  rut: string;
  email: string;
  telefono?: string;
  categoria: string;
  direccion?: string;
}

class ProveedoresAPI {
  // Listar proveedores
  async listar(params?: {
    search?: string;
    categoria?: string;
    activo?: boolean;
    page?: number;
    limit?: number;
  }): Promise<ListarProveedoresResponse> {
    const searchParams = new URLSearchParams();
    if (params?.search) searchParams.append('search', params.search);
    if (params?.categoria) searchParams.append('categoria', params.categoria);
    if (params?.activo !== undefined)
      searchParams.append('activo', params.activo.toString());
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());

    const response = await api.get(`/proveedores?${searchParams.toString()}`);
    return response.data;
  }

  // Obtener proveedor por ID
  async obtener(id: number): Promise<{ success: boolean; data: Proveedor }> {
    const response = await api.get(`/proveedores/${id}`);
    return response.data;
  }

  // Crear proveedor
  async crear(
    data: CreateProveedorRequest
  ): Promise<{ success: boolean; data: Proveedor; message: string }> {
    const response = await api.post('/proveedores', data);
    return response.data;
  }

  // Actualizar proveedor
  async actualizar(
    id: number,
    data: Partial<CreateProveedorRequest>
  ): Promise<{ success: boolean; data: Proveedor; message: string }> {
    const response = await api.put(`/proveedores/${id}`, data);
    return response.data;
  }

  // Eliminar (desactivar) proveedor
  async eliminar(
    id: number
  ): Promise<{ success: boolean; data: Proveedor; message: string }> {
    const response = await api.delete(`/proveedores/${id}`);
    return response.data;
  }

  // Reactivar proveedor
  async reactivar(
    id: number
  ): Promise<{ success: boolean; data: Proveedor; message: string }> {
    const response = await api.patch(`/proveedores/${id}/reactivar`);
    return response.data;
  }

  // Obtener categorías de proveedores
  async obtenerCategorias(): Promise<{
    success: boolean;
    total: number;
    data: string[];
  }> {
    const response = await api.get('/proveedores/categorias');
    return response.data;
  }
}

export const proveedoresAPI = new ProveedoresAPI();
export type { Proveedor, CreateProveedorRequest };
